import {
	IListAttrs,
	IListColumnConfig,
	IListOperations,
} from '@datachain/ui-sdk/common';
import produce, { immerable } from 'immer';
import { Map, Set } from 'immutable';

import { ChartItemEntity } from './chart-item.entity';

export interface IChartListExtra extends IListColumnConfig<ChartItemEntity> {
	width?: string | number;
	filterValue?: Array<string | number>;
	filterValues?: Array<string | number>;
	sortIndex?: number;
	sortOrder?: 'asc' | 'desc';
}

interface IChartListEntity extends IListAttrs<ChartItemEntity> {
	availableColumns: Map<string, IChartListExtra>;
}

const entityDefaults: IChartListEntity = {
	elements: Map(),
	availableColumns: Map(),
};

export class ChartListEntity
	implements
		IChartListEntity,
		IListOperations<ChartListEntity, ChartItemEntity>
{
	private [immerable] = true;
	public elements = entityDefaults.elements;
	public availableColumns = entityDefaults.availableColumns;

	public static build(availableCols: Array<IChartListExtra>): ChartListEntity {
		const instance = new ChartListEntity();
		const cols = availableCols.reduce((acc, curr) => {
			acc.push([curr.field, curr]);
			return acc;
		}, new Array<[string, IChartListExtra]>());

		instance.availableColumns = Map(cols);
		return instance;
	}

	private constructor() {}

	public getAvailableColumns(): Map<
		string,
		IListColumnConfig<ChartItemEntity>
	> {
		return this.availableColumns;
	}

	public setElements(elems: Map<string, ChartItemEntity>): ChartListEntity {
		return produce(this, (draft: ChartListEntity) => {
			draft.elements = elems;
		});
	}

	public extractUniqTags(...startValues: Array<string>): Set<string> {
		return this.elements.reduce((acc, chartItem) => {
			if (!chartItem.tags) {
				return acc;
			}
			return Set([
				...acc.toArray(),
				...chartItem.tags
					.toList()
					.toArray()
					.map((l) => l.label),
			]);
		}, Set<string>(startValues));
	}

	public extractModifiers(...startValues: Array<string>): Set<string> {
		return this.elements.reduce((acc, chartItem) => {
			if (chartItem.updatedByAvatar && chartItem.updatedByAvatar?.name) {
				acc = acc.add(chartItem.updatedByAvatar.name);
			}
			return acc;
		}, Set<string>(startValues));
	}

	public extractActionCreators(...startValues: Array<string>): Set<string> {
		return this.elements.reduce((acc, chartItem) => {
			if (chartItem.createdByAvatar && chartItem.createdByAvatar.name) {
				acc = acc.add(chartItem.createdByAvatar.name);
			}
			return acc;
		}, Set<string>(startValues));
	}
}
